<template lang="html">
  <div>
    <staff-item
      v-model="selectedItemId"
      :clone-id="cloneId"
    />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :search="true"
        :items="items"
        :headers="headers"
      >
        <template
          slot="photoUrlFull"
          slot-scope="props"
        >
          <v-avatar>
            <img
              v-if="props.item.photoUrlFull"
              :src="props.item.photoUrlFull"
            ><v-icon
              v-else
              size="55"
              color="grey darken-1"
            >
              mdi-account-circle
            </v-icon>
          </v-avatar>
        </template>
      </item-select-table>
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import StaffItem from './StaffItem'

export default {
  name: 'StaffList',
  components: {StaffItem},
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Staff User',
      types: 'Staff Users',
      headers: [
        this.headerSlot('', 'photoUrlFull', false, 'ft-thin-cell'),
        this.headerText('Username', 'username', true),
        this.headerText('Name', 'nameProper', true),
        this.headerDateTime('Last Login', 'lastLoggedIn', true),
        this.headerInvertedSwitch('Active', 'disabled')
      ],
      apiRecordCommand: 'staff'
    }
  },
  computed: {
  },
  methods: {
    listCommandFilter (command) {
      this.addCommandParamArrayVal(command, 'include_fields', 'nameProper', 'lastLoggedIn', 'photoUrlFull') // Include the users proper name and last logged in date
      return command
    }
  }
}
</script>
